import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { Select, Spin, DatePicker } from "antd";
import dayjs from "dayjs";
// import Swal from "sweetalert2";
import { getApiBaseUrl } from "../Config/Config";
const { Option } = Select;
const { RangePicker } = DatePicker;

const MyTasks = () => {
  const defaultStart = dayjs().subtract(5, "day");
  const defaultEnd = dayjs();

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([defaultStart, defaultEnd]);
  const [blocks, setBlocks] = useState([]);
  const [selectedBlockId, setSelectedBlockId] = useState(0);
  // const [modalVisible, setModalVisible] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState(null);
  // const [remarks, setRemarks] = useState("");
  // const [submitLoading, setSubmitLoading] = useState(false);

  const rangePresets = [
    {
      label: "Today",
      value: [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
      label: "This Week",
      value: [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: "Last 5 Days",
      value: [dayjs().subtract(5, "day"), dayjs()],
    },
  ];

  const fetchTasks = async (startDate, endDate) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/GetTasks?BlockId=${selectedBlockId}&startdate=${startDate}&enddate=${endDate}`
      );
      const result = await response.json();
      if (result?.Status && Array.isArray(result?.ResultData)) {
        setTasks(result.ResultData);
      } else {
        setTasks([]);
      }
    } catch (error) {
      console.error("Failed to fetch tasks:", error);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setDateRange(dates);
      fetchTasks(dateStrings[0], dateStrings[1]);
    } else {
      setDateRange([]);
      setTasks([]);
    }
  };

  useEffect(() => {
    const [start, end] = dateRange;
    fetchTasks(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
  }, [selectedBlockId]);

  const columns = [
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
    },
    {
      title: "Scheduled Date",
      dataIndex: "ScheduledDate",
      key: "ScheduledDate",
      // render: (date) => new Date(date).toLocaleDateString(),
      render: (text) => {
        if (!text) return "NA"; // handle null/empty case

        const date = new Date(text);
        const pad = (n) => (n < 10 ? "0" + n : n);

        const day = pad(date.getUTCDate());
        const month = pad(date.getUTCMonth() + 1);
        const year = date.getUTCFullYear();

        if (year < 2000) {
          return "NA";
        }

        return `${day}/${month}/${year}`;
      },
    },
    // {
    //   title: "Installed On",
    //   dataIndex: "InstalledOn",
    //   key: "InstalledOn",
    //   render: (date) => new Date(date).toLocaleDateString(),
    // },
    // {
    //   title: "Manufacturer",
    //   dataIndex: "Manufacturer",
    //   key: "Manufacturer",
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        const statusMap = {
          1: "Pending",
          2: "In Progress",
          3: "Completed",
        };
        return statusMap[value] || "Unknown";
      },
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   render: (_, record) => (
    //     <div className="action-table-data">
    //       <div className="d-flex align-items-start">
    //         <Link
    //           className="me-2 p-2"
    //           to="#"
    //           onClick={(e) => {
    //             e.preventDefault();
    //             setSelectedRecord(record);
    //             setModalVisible(true);
    //           }}
    //           title="Delete"
    //         >
    //           <i className="feather-trash text-info" data-feather="trash"></i>
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const data = await res.json();
        if (data?.Status !== false && Array.isArray(data?.ResultData)) {
          setBlocks(data.ResultData);
        }
      } catch (error) {
        console.error("Error fetching blocks:", error);
      }
    };

    fetchBlocks();
  }, []);
  // useEffect(() => {
  //   if (modalVisible) {
  //     setRemarks("");
  //   }
  // }, [modalVisible]);

  // const handleCancelTask = async () => {
  //   if (!remarks.trim()) {
  //     Swal.fire(
  //       "Remarks Required",
  //       "Please enter remarks before submitting.",
  //       "warning"
  //     );
  //     return;
  //   }

  //   const user = JSON.parse(sessionStorage.getItem("user"));
  //   const performedBy = user?.UserID || 0;
  //   const statusMap = {
  //     1: "Pending",
  //     2: "In Progress",
  //     3: "Completed",
  //   };
  //   const payload = {
  //     id: selectedRecord?.id,
  //     remarks: remarks,
  //     updatedby: performedBy,
  //   };

  //   try {
  //     setSubmitLoading(true);

  //     const res = await fetch(`${getApiBaseUrl()}/api/canceltasks`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const result = await res.json();

  //     // Success or failure flag
  //     const isSuccess =
  //       result?.Status && result?.ResultData?.[0]?.Status === "Success";

  //     if (isSuccess) {
  //       Swal.fire("Success", "Task Deleted successfully.", "success").then(
  //         () => {
  //           setModalVisible(false);
  //           setRemarks("");
  //           fetchTasks();
  //           window.location.reload();
  //         }
  //       );
  //     } else {
  //       Swal.fire(
  //         "Error",
  //         result?.ResultData?.[0]?.ResultMessage ||
  //           result?.Message ||
  //           "Failed to cancel task",
  //         "error"
  //       );
  //     }

  //     // Always log activity
  //     const performedOn = new Date()
  //       .toISOString()
  //       .slice(0, 19)
  //       .replace("T", " ");
  //     const activityPayload = {
  //       ActivityType: 1, // keep as is
  //       PerformedBy: performedBy, // user
  //       PerformedOn: performedOn,
  //       Notes: `${
  //         statusMap[selectedRecord?.status]
  //       } task, deleted for filter: ${selectedRecord?.Lable}`,
  //       Location: "login", // keep as is
  //       IsSucces: isSuccess ? 1 : 0,
  //     };

  //     await fetch(`${getApiBaseUrl()}/addActivity`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(activityPayload),
  //     }).catch((err) =>
  //       console.error("Error logging task deletion activity:", err)
  //     );
  //   } catch (err) {
  //     Swal.fire("Error", "Unexpected error occurred.", "error");
  //     console.error("Cancel task error:", err);

  //     // log failure as well
  //     const performedOn = new Date()
  //       .toISOString()
  //       .slice(0, 19)
  //       .replace("T", " ");
  //     const activityPayload = {
  //       ActivityType: 1,
  //       PerformedBy: performedBy,
  //       PerformedOn: performedOn,
  //       Notes: `${
  //         statusMap[selectedRecord?.status]
  //       } task, deleted for filter: ${selectedRecord?.Lable}`,
  //       Location: "login",
  //       IsSucces: 0,
  //     };
  //     await fetch(`${getApiBaseUrl()}/addActivity`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(activityPayload),
  //     }).catch((err) =>
  //       console.error("Error logging failed task deletion activity:", err)
  //     );
  //   } finally {
  //     setSubmitLoading(false);
  //   }
  // };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    MyTasks
                  </h4>
                </ol>
              </nav>
              <h6>Manage Tasks here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li></li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set m-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="d-flex flex-column me-3">
                <label className="form-label mb-1">From date - To date</label>
                <RangePicker
                  presets={rangePresets}
                  onChange={onRangeChange}
                  value={dateRange}
                />
              </div>
              <div className="d-flex flex-column me-3">
                <label className="form-label mb-1">Blocks</label>
                <Select
                  placeholder="Select Block"
                  style={{ width: 200 }}
                  onChange={(value) => setSelectedBlockId(value)}
                  value={selectedBlockId}
                >
                  <Option value={0}>All</Option>
                  {blocks.map((block) => (
                    <Option key={block.BlockId} value={block.BlockId}>
                      {block.BlockName}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : tasks.length > 0 ? (
                <Table columns={columns} dataSource={tasks} />
              ) : (
                <p className="text-center my-4">No data available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <Modal
        title="Delete Task"
        open={modalVisible}
        onOk={handleCancelTask}
        onCancel={() => {
          setModalVisible(false);
          setRemarks("");
        }}
        confirmLoading={submitLoading}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{ style: { backgroundColor: "#0d6efd" } }}
        cancelButtonProps={{
          style: { backgroundColor: "#d33", color: "#fff" },
        }}
      >
        <p>Do you want to delete this task?</p>
        <label htmlFor="remarks">Remarks</label>
        <Input.TextArea
          id="remarks"
          placeholder="Enter your remarks here..."
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          rows={4}
        />
      </Modal> */}
    </div>
  );
};

export default MyTasks;
